import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {LoginComponent} from "@app/login/login.component";
import {MatDialog} from "@angular/material/dialog";
import {PortalUser} from "@app/model/portal-user.model";
import {Router} from "@angular/router";
import {GlobalSpinnerService} from "@app/services/misc-services/global-spinner.service";
import {LoginService} from "@app/login/login.service";

@Component({
    selector: 'flex-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SigninComponent implements OnInit {

    constructor(public dialog: MatDialog, private router: Router, private globalSpinner: GlobalSpinnerService, private loginService: LoginService) {
    }

    ngOnInit(): void {
        this.loginService.signout();
        this.openDialog()
    }

    openDialog() {
        const dialogRef = this.dialog.open(LoginComponent, {disableClose: true, autoFocus: true, hasBackdrop: false});
        dialogRef.afterClosed().subscribe((user: PortalUser) => {
            this.loginService.activeUser = user;
            setTimeout(() => {
                this.router.navigate(['/news']);
                this.globalSpinner.removeEvent('signin');
            }, 1000)

        });
    }

}
